import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GasIconNotificationComponent } from './bundles/notifications/gas-icon-notification.component';
import { GasIconCoreComponent } from './bundles/core/gas-icon-core.component';
import { GasIconComponent } from './icon/gas-icon.component';
import { GasIconDefinitionsComponent } from './definitions/gas-icon-definitions.component';
import { GasBgIconDirective } from './directive/gas-bg-icon.directive';
import { GasIconActionsComponent } from './bundles/actions/gas-icon-actions.component';
import { GasIconArrowsComponent } from './bundles/arrows/gas-icon-arrows.component';
import { GasIconLayoutComponent } from './bundles/layout/gas-icon-layout.component';
import { GasIconCommonComponent } from './bundles/common/gas-icon-common.component';
import { GasIconNavigationComponent } from './bundles/navigation/gas-icon-navigation.component';
import { GasIconMenuComponent } from './bundles/menu/gas-icon-menu.component';

const COMPONENTS = [
  GasIconComponent,
  GasIconDefinitionsComponent,
  GasIconCommonComponent,
];

const INNER_COMPONENTS = [
  GasIconNotificationComponent,
  GasIconCoreComponent,
  GasIconActionsComponent,
  GasIconArrowsComponent,
  GasIconLayoutComponent,
  GasIconNavigationComponent,
  GasIconMenuComponent,
];

const DIRECTIVES = [
  GasBgIconDirective,
];

/**
 * @description Component for icons
 * @description For use just add input 'name' and set icon name
 * @description Icon name you can find in GasIcon namespace
 * @description Inputs:
 * @description name - name of icon, can find in GasIcon namespace
 * @description size - combine of width and height
 * @description color - color of icon
 * @example <gas-icon name="navigations-warning"></gas-icon>
 */
@NgModule({
  declarations: [
    COMPONENTS,
    INNER_COMPONENTS,
    DIRECTIVES,
  ],
  exports: [
    COMPONENTS,
    DIRECTIVES,
  ],
  entryComponents: [
    COMPONENTS,
  ],
  imports: [
    CommonModule,
  ],
})
export class GasIconsModule { }
